var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9997 4.49992C11.887 4.49992 4.49967 11.8872 4.49967 20.9999C4.49967 30.1127 11.887 37.4999 20.9997 37.4999C30.1124 37.4999 37.4997 30.1127 37.4997 20.9999C37.4997 11.8872 30.1124 4.49992 20.9997 4.49992ZM0.833008 20.9999C0.833008 9.86218 9.86194 0.833252 20.9997 0.833252C32.1374 0.833252 41.1663 9.86218 41.1663 20.9999C41.1663 32.1376 32.1374 41.1666 20.9997 41.1666C9.86194 41.1666 0.833008 32.1376 0.833008 20.9999ZM20.9997 9.99992C22.0122 9.99992 22.833 10.8207 22.833 11.8333V22.8333C22.833 23.8458 22.0122 24.6666 20.9997 24.6666C19.9871 24.6666 19.1663 23.8458 19.1663 22.8333V11.8333C19.1663 10.8207 19.9871 9.99992 20.9997 9.99992ZM20.9997 31.9999C22.0122 31.9999 22.833 31.1791 22.833 30.1666C22.833 29.154 22.0122 28.3333 20.9997 28.3333C19.9871 28.3333 19.1663 29.154 19.1663 30.1666C19.1663 31.1791 19.9871 31.9999 20.9997 31.9999Z",
    fill: "#D10000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessageIcon);
export default __webpack_public_path__ + "static/media/errorMessageIcon.e028820731f16f4041fea9dd5dabb158.svg";
export { ForwardRef as ReactComponent };